interface Window {
    getPagination: (
        currentPage: number,
        totalPages: number,
        hasPreviousPage: boolean,
        hasNextPage: boolean
    ) => void;
    getPageListHtml: (
        pageIndex: number,
        currentPage: number,
        previousPage: boolean,
        nextPage: boolean,
        showDots: boolean
    ) => string;

    PreviousText: string;
    NextText: string;
    PagerArrowLeftImgPath: string;
    PagerArrowRightImgPath: string;
}

window.getPagination = function (
    currentPage: number,
    totalPages: number,
    hasPreviousPage: boolean,
    hasNextPage: boolean
): void {
    let pagination = $("#pagination");
    if (totalPages <= 1)
        pagination.html('');

    let result = '';
    let i: number | undefined;

    if (hasPreviousPage)
        result += window.getPageListHtml(
            currentPage - 1,
            currentPage,
            true,
            false,
            false
        );

    result += window.getPageListHtml(1, currentPage, false, false, false);

    let gobackTill = Math.max(2, currentPage - 2);
    let goForwardTill = Math.min(gobackTill + 2, currentPage - 1);

    if (gobackTill > 2)
        result += window.getPageListHtml(
            Math.ceil(gobackTill / 2),
            currentPage,
            false,
            false,
            true
        );

    for (i = gobackTill; i <= goForwardTill; i++)
        result += window.getPageListHtml(i, currentPage, false, false, false);

    if (currentPage !== 1)
        result += window.getPageListHtml(
            currentPage,
            currentPage,
            false,
            false,
            false
        );

    for (i = currentPage + 1; i < totalPages && i < currentPage + 3; i++)
        result += window.getPageListHtml(i, currentPage, false, false, false);

    if (i < totalPages)
        result += window.getPageListHtml(
            Math.ceil((i + totalPages) / 2),
            currentPage,
            false,
            false,
            true
        );

    if (totalPages !== currentPage)
        result += window.getPageListHtml(
            totalPages,
            currentPage,
            false,
            false,
            false
        );

    if (hasNextPage)
        result += window.getPageListHtml(
            currentPage + 1,
            currentPage,
            false,
            true,
            false
        );

    pagination.html(result);
};

window.getPageListHtml = function (
    pageIndex: number,
    currentPage: number,
    previousPage: boolean,
    nextPage: boolean,
    showDots: boolean
): string {
    let pageAnchorHtml = pageIndex;
    if (previousPage || nextPage)
        return `<img src="${previousPage ? window.PagerArrowLeftImgPath : window.PagerArrowRightImgPath}" alt="${previousPage ? window.PreviousText : window.NextText}" class="v-middle">`;
    else if (showDots)
        return  '...';

    let pageAnchorLink = pageIndex;
    if (pageIndex !== currentPage)
        return `<a href="?pagenumber=${pageIndex}" title="${previousPage ? window.PreviousText : ''}${nextPage ? window.NextText : ''}">${pageAnchorHtml}</a>`;

    return `<li>${pageAnchorLink}</li>`;
};
